function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Viewlist({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.537 1c1.654 0 3 1.346 3 3v15.926c0 1.654-1.346 3-3 3H6c-1.654 0-3-1.346-3-3V4c0-1.654 1.346-3 3-3h12.537zm0 2H6c-.551 0-1 .448-1 1v15.926c0 .552.449 1 1 1h12.537a1 1 0 001-1V4a1 1 0 00-1-1zM7.854 14.929a1 1 0 110 2h-.147a1 1 0 110-2h.147zm9.08-.073a1 1 0 110 2h-6a1 1 0 110-2h6zm-9.08-3.922a1 1 0 110 2h-.147a1 1 0 010-2h.147zm9.08 0a1 1 0 110 2h-6a1 1 0 110-2h6zM7.855 7.01a1 1 0 110 2h-.147a1 1 0 010-2h.147zm9.08 0a1 1 0 110 2h-6a1 1 0 110-2h6z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoViewlist = React.memo(Viewlist);
export default MemoViewlist;